import React, { useLayoutEffect, useRef } from "react";
import { NavbarContainer } from "./NavbarStyles";
const NavBar = ({ top, fixedWidth, setWidth, zIndex, children }) => {
    const ref = useRef(null);
    useLayoutEffect(() => {
        if (!fixedWidth && ref.current && setWidth) {
            setWidth(ref.current.offsetWidth);
        }
    }, [ref, setWidth]);
    return (React.createElement(NavbarContainer, { top: top, zIndex: zIndex, ref: ref }, children));
};
export default NavBar;
//# sourceMappingURL=Navbar.js.map